<script setup lang="ts">
import { useDisplay } from 'vuetify';


defineOptions({
  name: 'LayoutAccount',
});

const { smAndDown } = useDisplay();
const { isMobileShell } = useMobileShell();

const drawer = ref({
  drawer: !smAndDown.value,
  rail: true,
});
</script>

<template>
  <v-app>
    <template v-if="isMobileShell">
      <LazyMobileAppBar />

      <v-main>
        <v-container
          :class="$style['mobile-container']"
          fluid
        >
          <slot />
        </v-container>
      </v-main>

      <LazyMobileBottomNav />
    </template>

    <template v-else>
      <LazyDashboardDrawer v-model="drawer" />

      <LazyDashboardAppBar
        v-model="drawer"
        :activeRouteName="'activeRouteName'"
        :pageName="'pageName'"
        :activeRoute="'activeRoute'"
        showTabs
      />

      <v-main>
        <v-container fluid>
          <slot />
        </v-container>
      </v-main>

      <LazyDashboardFooter />
    </template>
  </v-app>
</template>

<style module lang="scss">
.mobile-container {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
}
</style>
